<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title"> Параметры сайта</h3><br>
                <div class="card-tools">
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                  <div class="container">
                   <span v-for="option in options.data" :key="option.id">
<!--                      <div class="form-group">-->
<!--                      <label>Имя сайта:</label>-->
<!--                      <input v-model="option.sitename" type="text" name="sitename"-->
<!--                             class="form-control" :class="{ 'is-invalid': form.errors.has('sitename') }">-->
<!--                      <has-error :form="form" field="sitename"></has-error>-->
<!--                  </div>-->

<!--                  <div class="form-group">-->
<!--                      <label>Почта</label>-->
<!--                      <input v-model="option.mail_to" type="text" name="mail_to"-->
<!--                             class="form-control" :class="{ 'is-invalid': form.errors.has('mail_to') }">-->
<!--                      <has-error :form="form" field="mail_to"></has-error>-->
<!--                  </div>-->
<!--                  <div class="form-group">-->
<!--                      <label>Версия ПО </label>-->
<!--                      <input v-model="option.ver" type="text" name="ver"-->
<!--                             class="form-control" :class="{ 'is-invalid': form.errors.has('ver') }">-->
<!--                      <has-error :form="form" field="ver"></has-error>-->
<!--                  </div>-->

                  <div class="form-group">
                      <label>Телефон 1</label>
                      <input v-model="option.phone" type="text" name="phone"
                             class="form-control" :class="{ 'is-invalid': form.errors.has('phone') }">
                      <has-error :form="form" field="phone"></has-error>
                  </div>
                     <div class="form-group">
                      <label>Телефон 2</label>
                      <input v-model="option.phone2" type="text" name="phone2"
                             class="form-control" :class="{ 'is-invalid': form.errors.has('phone2') }">
                      <has-error :form="form" field="phone2"></has-error>
                  </div>
                     <div class="form-group">
                      <label>Телефон 3</label>
                      <input v-model="option.phone3" type="text" name="phone3"
                             class="form-control" :class="{ 'is-invalid': form.errors.has('phone3') }">
                      <has-error :form="form" field="phone3"></has-error>
                  </div>


<!--                  <div class="form-group">-->
<!--                      <label>Открытый ключ для google капчи:</label>-->
<!--                      <input v-model="option.tokeno" type="text" name="tokeno"-->
<!--                             class="form-control" :class="{ 'is-invalid': form.errors.has('tokeno') }">-->
<!--                      <has-error :form="form" field="tokeno"></has-error>-->
<!--                  </div>-->
<!--                  <div class="form-group">-->
<!--                      <label>Закрытый ключ для google капчи:</label>-->
<!--                      <input v-model="option.tokenc" type="text" name="tokenc"-->
<!--                             class="form-control" :class="{ 'is-invalid': form.errors.has('tokenc') }">-->
<!--                      <has-error :form="form" field="tokenc"></has-error>-->
<!--                  </div>-->
<!--                  <div class="form-group">-->
<!--                      <label>Токен для бота:</label>-->
<!--                      <input v-model="option.tokent" type="text" name="tokent"-->
<!--                             class="form-control" :class="{ 'is-invalid': form.errors.has('tokent') }">-->
<!--                      <has-error :form="form" field="tokent"></has-error>-->
<!--                  </div>-->
<!--                  <div class="form-group">-->
<!--                      <label>ID получателя, получать тут-->
<!--                          http://t.me/userinfobot:</label>-->
<!--                      <input v-model="option.telegramid" type="text" name="telegramid"-->
<!--                             class="form-control" :class="{ 'is-invalid': form.errors.has('telegramid') }">-->
<!--                      <has-error :form="form" field="telegramid"></has-error>-->
<!--                  </div>-->
                  </span>
                  </div>
                  <div class="form-group ">
                      <label></label>
                      <div class="col-md-12">
                      </div>
                  </div>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                  <input type="button" class="btn btn-primary" v-on:click="updateOption()"  value="Сохранить">

              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>

    </div>
  </section>
</template>

<script>
    import VueTagsInput from '@johmun/vue-tags-input';

    export default {
      components: {
          VueTagsInput,
        },
        data () {
            return {
                editmode: false,
                options : {},
                form: new Form({
                    id : '',
                    // sitename : '',
                    phone: '',
                    phone2: '',
                    phone3: '',
                    // mail_to: '',
                    // ver: '',
                    // mail: '',
                    // tokeno: '',
                    // tokenc: '',
                    // tokent: '',
                    // telegramid: '',
                }),
                autocompleteItems: [],

            }
        },
        methods: {
          loadOptions(){
            // if(this.$gate.isAdmin()){
              axios.get("api/option").then(({ data }) => (this.options = data.data));
            // }
          },
            searchInTheList(searchText){
                        console.log(searchText);
                        return searchText;
                },
          updateOption(){
              this.$Progress.start();
              //console.log(this.options['data'][0] );
              axios.put('api/option/1', {
                      // id: this.options['data'][0]['id'],
                      // sitename: this.options['data'][0]['sitename'],
                      // mail_to: this.options['data'][0]['mail_to'],
                      // ver: this.options['data'][0]['ver'],
                      phone: this.options['data'][0]['phone'],
                      phone2: this.options['data'][0]['phone2'],
                      phone3: this.options['data'][0]['phone3'],
                      // tokeno: this.options['data'][0]['tokeno'],
                      // tokenc: this.options['data'][0]['tokenc'],
                      // tokent: this.options['data'][0]['tokent'],
                      // telegramid: this.options['data'][0]['telegramid'],
              })
                  .then((response) => {
                  // success
                  Toast.fire({
                    icon: 'success',
                    title: response.data.message
                  });
                  this.$Progress.finish();
                      //  Fire.$emit('AfterCreate');
                 // this.loadOptions();
              })
              .catch(() => {
                  this.$Progress.fail();
              });
          },
        },
        mounted() {

        },
        created() {
            this.$Progress.start();
            this.loadOptions();
           // this.updateOption();
            this.$Progress.finish();
        },
        filters: {
            truncate: function (text, length, suffix) {
                return text.substring(0, length) + suffix;
            },
        },
        computed: {
          filteredItems() {
            return this.autocompleteItems.filter(i => {
              return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
            });
          },
        },
    }
</script>
